import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Guide } from '@/features/guides/guidesSlice.ts';

export interface User {
  id?: string;
  name?: string;
  email?: string;
  avatar?: string;
  last_guides?: Guide[];
  saved_guides?: Guide[];
  tokens?: number;
}

export interface ProfileContentProps {
  user: User;
}

interface UserState {
  isAuthenticated: boolean;
  profile: {
    id?: string;
    name?: string;
    email?: string;
    avatar?: string;
    last_guides?: Guide[];
    saved_guides?: Guide[];
  };
  loading: boolean;
  error: string | null;
  preferences: {
    mapStyle: 'default' | 'dark' | 'light' | 'theme_color';
  };
}

const initialState: UserState = {
  isAuthenticated: false,
  profile: {},
  loading: false,
  error: null,
  preferences: {
    mapStyle: 'default',
  },
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<User>) => {
      state.isAuthenticated = true;
      state.profile = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.profile = {};
    },
    updateProfile: (state, action: PayloadAction<Partial<UserState['profile']>>) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    updateMapStyle: (state, action: PayloadAction<'default' | 'dark' | 'light' | 'theme_color'>) => {
      state.preferences.mapStyle = action.payload;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateProfile, updateMapStyle } = userSlice.actions;

export default userSlice.reducer;
